<template>
    <b-card no-body>
        <b-modal id="upload" title="Göstergeleri Sisteme Yükle" no-close-on-esc no-close-on-backdrop>
            <upload-inflation v-model="indicator" :groups="groups"></upload-inflation>
            <template #modal-footer><v-executer :disabled="!indicator.EntityFileType" :loading="loading" text="Yükle" :action="upload"></v-executer></template>
        </b-modal>


        <v-table    ref="table"
                    with-items
                    name="inflation"
                    :items="items"
                    :row-slot="activeType == 'TWO_YEAR' ? 'out':'default'"
                    :fields="activeType == 'TWO_YEAR' ? fieldForTwoYears : fields">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-xl-4 mb-1 mb-xl-0">
                                    <select class="form-control" v-model="type">
                                        <optgroup v-for="(group,index) in groups" :key="'g'+index" :label="group.name">
                                            <option v-for="(type,index) in group.types" :key="'t'+index" :value="type.key">
                                                {{type.name}}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="col-xl-auto mb-1 mb-xl-0">
                                    <button class="btn btn-success w-100" v-on:click="getInflationData">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-xl-auto">
                                    <button class="btn btn-primary w-100" v-on:click="openUplaoder">
                                        Göstergeleri Sisteme Yükle
                                    </button>
                                </div>
                            </div>
                        </template>
                        <template #row-out="{ row }">
                            <tr><td><b>{{getTypeName(row.Type)}}</b></td></tr>
                            <tr>
                                <td>
                                    <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>Yıl</th>
                                                <th>Ocak</th>
                                                <th>Şubat</th>
                                                <th>Mart</th>
                                                <th>Nisan</th>
                                                <th>Mayıs</th>
                                                <th>Haziran</th>
                                                <th>Temmuz</th>
                                                <th>Ağustos</th>
                                                <th>Eylül</th>
                                                <th>Ekim</th>
                                                <th>Kasım</th>
                                                <th>Aralık</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            <tr v-for="(item,index) in row.InflationDatas" :key="index">
                                                <td>{{item.Year ? item.Year : '-'}}</td>
                                                <td>{{item.January ? item.January : '-'}}</td>
                                                <td>{{item.February ? item.February : '-'}}</td>
                                                <td>{{item.March ? item.March : '-'}}</td>
                                                <td>{{item.April ? item.April : '-'}}</td>
                                                <td>{{item.May ? item.May : '-'}}</td>
                                                <td>{{item.June ? item.June : '-'}}</td>
                                                <td>{{item.July ? item.July : '-'}}</td>
                                                <td>{{item.August ? item.August : '-'}}</td>
                                                <td>{{item.September ? item.September : '-'}}</td>
                                                <td>{{item.October ? item.October : '-'}}</td>
                                                <td>{{item.November ? item.November : '-'}}</td>
                                                <td>{{item.December ? item.December : '-'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import InflationApi from '@/api/inflation'
import UploadInflation from './components/UploadInflation'
import Additional from '@/utilities/additional'
export default {
    components:{
        BCard,
        UploadInflation,
    },
    data(){
        return{
            groups:[
                { 
                    name:"YILLIK",
                    types:[
                        {name:"TUFE - Bir önceki aya göre değişim (%)",key:"TUFEMonthly"},
                        {name:"UFE - Bir önceki aya göre değişim (%)",key:"UFEMonthly"},
                        {name:"TUFE - Bir önceki yılın Aralık ayına göre değişim (%)",key:"TUFELastDecember"},
                        {name:"UFE - Bir önceki yılın Aralık ayına göre değişim (%)",key:"UFELastDecember"},
                    ],
                },
                { 
                    name:"2 YILLIK",
                    types:[
                        {name:"Son iki Yılın Gösterge Verileri",key:"TWO_YEAR"},
                    ],
                }
            ],
            type:"TUFEMonthly",
            activeType:"TUFEMonthly",
            indicator:{
                EntityFileType:null,
                File:null,
                EntityName:"Inflation"
            },
            loading:false,
            fields:[
                { name:"Yıl",key:"Year" },
                { name:"Ocak",key:"January"},
                { name:"Şubat",key:"February"},
                { name:"Mart",key:"March"},
                { name:"Nisan",key:"April"},
                { name:"Mayıs",key:"May"},
                { name:"Haziran",key:"June"},
                { name:"Temmuz",key:"July"},
                { name:"Ağustos",key:"August"},
                { name:"Eylül",key:"September"},
                { name:"Ekim",key:"October"},
                { name:"Kasım",key:"November"},
                { name:"Aralık",key:"December"},
            ],
            fieldForTwoYears:[
                {name:"Tip",key:"Type"},
            ],
            items:[],
        }
    },
    methods:{
        getTypeName(type){
            return this.groups.find(g=>g.name=="YILLIK").types.find(t=>t.key==type).name
        },
        clearForm(){
            this.indicator.Type = null
            this.indicator.File = null
        },
        openUplaoder(){
            this.clearForm()
            this.$showModal("upload")
        },
        async upload(){
            this.loading = true
            const formData = await Additional.ToFormData(this.indicator,["File"])
            InflationApi.UploadFile(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal("upload")
                    this.type = this.indicator.EntityFileType
                    this.getInflationData()
                    this.clearForm()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        getInflationData(){
            if(this.type == "TWO_YEAR"){
                this.$refs.table.setLoading(true)
                InflationApi.GetLastTwoYears().then(response => {
                    this.items = response.data.Data
                    this.$refs.table.setLoading(false)
                    this.activeType = this.type
                }).catch(error => {
                    this.$result(null,error)
                    this.$refs.table.setLoading(false)
                })
            }else{
                this.$refs.table.setLoading(true)
                InflationApi.Get(this.type).then(response => {
                    this.items = response.data.Data
                    this.$refs.table.setLoading(false)
                    this.activeType = this.type
                }).catch(error => {
                    this.$result(null,error)
                    this.$refs.table.setLoading(false)
                })
            }
        }
    }
}
</script>

<style>

</style>